<template>
  <div class="kpt-docu-categories">
    <div class="kpt-card-grid">
      <div class="box has-cursor-pointer" @click="$emit('select', topic)" v-for="(topic, index) in topics" :key="index">
        <div class="level">
          <div class="level-left">
            <div class="level-item"><font-awesome-icon :icon="['far', 'folder']" size="2x" transform="shrink-2" /></div>
            <div class="level-item"><h5><strong>{{topic}}</strong></h5></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    topics: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/_mixins';
@import '../../styles/_colors';
.kpt-docu-categories {
  .kpt-card-grid {
    & :hover {
      background-color: $grey-lighter;
    }
    @include display-grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    .box {
      margin-bottom: 0 !important;
      padding: 0.75em;
    }
  }
}
</style>
